/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import stylesheet
 */
// import "../scss/ic-shop.scss";

/**
 * Import modules / classes
 */
import MallMap from "./modules/ic-shop/MallMap";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const myMallMap = new MallMap();
});
